import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=7ad3c590&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=7ad3c590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad3c590",
  null
  
)

export default component.exports